import {
    SET_CURRENT_VTO,
    TOGGLE_VTO,
    SET_VTO_MESSAGE,
    RESET_VTO_MESSAGE,
} from '../actionTypes/VirtualTryOnActionTypes';

function VirtualTryOnReducer(state = {}, action) {
    switch (action.type) {
        case SET_CURRENT_VTO:
            return { ...state, ...action.payload };
        case TOGGLE_VTO: {
            return { ...state, ...action.payload };
        }
        case SET_VTO_MESSAGE: {
            return { ...state, message: action.payload };
        }
        case RESET_VTO_MESSAGE: {
            return { ...state, message: [] };
        }
        default:
            return state;
    }
}

export default VirtualTryOnReducer;
